import { Button, Card, Flex, Icon, Text } from '@servicetitan/anvil2';
import Launch from '@servicetitan/anvil2/assets/icons/material/round/launch.svg';
import { openWebUrl } from '@servicetitan/financing-utils-shared';
import { SetupDataStore, useSecondLookProviderName } from '@servicetitan/financing-workflow-shared';
import { DecisionDataStore } from '../stores/DecisionDataStore';

/**
 * Offers the second-look provider's own marketplace of alternative lenders after it has declined
 * the applicant. Requires both halves of a dual decline: the second look must have declined, and
 * the provider only returns a decline redirect for tenants enrolled in that marketplace. Without a
 * second-look decline, SecondLookFinancingOption owns the offer to the applicant instead.
 */
export const ExploreMoreOptions = () => {
    const { setupData } = SetupDataStore.useStore();
    const { decisionData } = DecisionDataStore.useStore();
    const secondLookProviderName = useSecondLookProviderName();
    const declineRedirectUrl = decisionData?.declineRedirectUrl;

    if (!decisionData?.secondLookDeclined || !declineRedirectUrl) {
        return null;
    }

    return (
        <Card
            data-testid="explore-more-options"
            flexDirection="column"
            style={{ maxWidth: '845px', width: '100%' }}
        >
            <Flex gap="3" direction="column" justifyContent="center">
                <Text variant="headline" el="h2" size="small" style={{ textAlign: 'center' }}>
                    Explore more financing options
                </Text>
                <Text variant="body" color="secondary" style={{ textAlign: 'center' }}>
                    {secondLookProviderName} may be able to provide you with alternative options.
                    Additional information may be required to qualify.
                </Text>
                <Button
                    type="button"
                    appearance="secondary"
                    style={{ width: '100%' }}
                    onClick={() => openWebUrl(declineRedirectUrl, setupData?.useInAppBrowser)}
                >
                    Explore Options
                    <Icon inherit aria-hidden svg={Launch} />
                </Button>
            </Flex>
        </Card>
    );
};
